import { convertStringToDate } from './convertStringToDate';
import { formatInscricao } from './formatInscricao';
import { maskAddressNumber } from './MaskAddressNumber';
import { maskAge } from './MaskAge';
import { maskAmount } from './MaskAmount';
import { maskCEP } from './MaskCep';
import { maskCnpj } from './MaskCnpj';
import { maskCpf } from './MaskCpf';
import { maskDate } from './MaskDate';
import { maskFee } from './MaskFee';
import { maskIntegerNumber } from './MaskIntegerNumber';
import { maskMoney } from './MaskMoney';
import { maskName } from './MaskName';
import { maskPhoneNumber } from './MaskPhoneNumber';
import { maskStringNumber } from './MaskStringNumber';
import { unmaskCEP } from './UnMaskCep';
import { unmaskCnpj } from './UnMaskCnpj';
import { unmaskCpf } from './UnMaskCpf';
import { unmaskFee } from './UnMaskFee';
import { unmaskMoney } from './UnMaskMoney';
import { unmaskPhoneNumber } from './UnMaskPhoneNumber';

interface MasksProps {
  [key: string]: {
    apply: (value: string) => string;
    remove: (value: string) => string | number | Date;
  };
}

export const applyMasks = (obj: any): any => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  const newObj: { [key: string]: any } = Array.isArray(obj) ? [] : {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      if (masks[key]) {
        newObj[key] = masks[key].apply(value);
      } else {
        newObj[key] = applyMasks(value); // Recursive call
      }
    }
  }

  return newObj;
};

export const removeMasks = (obj: any): any => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  const newObj: { [key: string]: any } = Array.isArray(obj) ? [] : {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (value instanceof File) {
        newObj[key] = value;
      } else if (masks[key]) {
        newObj[key] = masks[key].remove(value);
      } else {
        newObj[key] = removeMasks(value); // Recursive call
      }
    }
  }

  return newObj;
};

const createDateMask = (key: string) => {
  return {
    [key]: {
      apply: maskDate,
      remove: (value: string) => convertStringToDate(value),
    },
  };
};

const dateKeys = [
  'data_nascimento',
  'data_inicio',
  'data_termino',
  'inicio_vendas',
  'termino_vendas',
];

const dateMasks = dateKeys.reduce((acc, key) => ({ ...acc, ...createDateMask(key) }), {});

export const masks: MasksProps = {
  // Máscaras do Esteio Gestão
  rfid: {
    apply: (value: string) => maskStringNumber(value),
    remove: (value: string) => value,
  },
  // Permite apenas números inteiros. O número é separado por ponto na casa dos milhares
  alturaEntrada: {
    apply: (value: string) => maskIntegerNumber(value),
    remove: (value: string) => value,
  },

  // Permite escrever apenas letras
  nome: { apply: maskName, remove: (value: string) => value },
  cpf: { apply: maskCpf, remove: unmaskCpf },
  cnpj: { apply: maskCnpj, remove: unmaskCnpj },
  telefone: { apply: maskPhoneNumber, remove: unmaskPhoneNumber },
  telefone_2: { apply: maskPhoneNumber, remove: unmaskPhoneNumber },
  cep: { apply: maskCEP, remove: unmaskCEP },
  classificacao_etaria: { apply: maskAge, remove: (value: string) => value },
  quantidade_disponivel: { apply: maskAmount, remove: (value: string) => value },
  quantidade: { apply: (value: string) => maskAmount(value, 3), remove: (value: string) => value },
  max_ingressos: { apply: (value: string) => maskAmount(value), remove: (value: string) => value },
  quantidade_compra: { apply: maskAmount, remove: (value: string) => value },
  valor: { apply: maskMoney, remove: unmaskMoney },
  taxa: { apply: maskFee, remove: unmaskFee },
  percentual_desconto: { apply: maskFee, remove: unmaskFee },
  numero: { apply: maskAddressNumber, remove: (value: string) => value },
  inscricao_estadual: { apply: formatInscricao, remove: (value: string) => value },
  inscricao_municipal: { apply: formatInscricao, remove: (value: string) => value },
  ...dateMasks,
};
